/**
 * Meoded Color Picker — Shopify Asset (forked from bm-color-picker.js)
 * File: assets/meoded-color-picker.js
 *
 * Same behavior as the Benjamin Moore picker, but with Meoded's own
 * color list and its own DOM ids/classes (md- prefix) so both scripts
 * can coexist in the theme without colliding.
 *
 * Color list pulled from https://meodedpaint.com/product/lime-wash/
 * (names + codes read from the product's color dropdown). Swatch
 * photos are Kyle's own images, uploaded to Shopify Files and
 * referenced here by their CDN URL. Hex values are only a fallback
 * background shown before the photo loads / if it 404s.
 */

(function () {
  'use strict';

  const CDN_BASE = 'https://cdn.shopify.com/s/files/1/0789/0095/3327/files/';

  const MEODED_COLORS = [
    ['Natural White', 'MC-701', '#F6F2E8', 'White', 'MC-701-Natural-White.jpg'],
    ['Kasper', 'MC-703', '#DCCEB4', 'Neutral', 'MC-703-Kasper.jpg'],
    ['White Dove', 'MC-706', '#F1EEE5', 'White', 'MC-706-White-Dove.jpg'],
    ['Pure White', 'MC-709', '#FAF8F3', 'White', 'MC-709_Pure_White.jpg'],
    ['Designer White', 'MC-711', '#F4F1E7', 'White', 'MC-711_Designer_White.jpg'],
    ['Calm White', 'MC-715', '#F0EDE3', 'White', 'MC-715_Calm_White.jpg'],
    ['Creative White', 'MC-718', '#ECE8DD', 'White', 'MC-718_Creative_White.jpg'],
    ['Cumulous', 'MC-721', '#E7E2D5', 'White', 'MC-721_Cumulous.jpg'],
    ['Latte', 'MC-725', '#D5C3A3', 'Neutral', 'MC-725_Latte.jpg'],
    ['Creamer', 'MC-728', '#E7DABD', 'Neutral', 'MC-728_Creamer.jpg'],
    ['Origata', 'MC-730', '#CEBC9A', 'Neutral', 'MC-730_Origata.jpg'],
    ['Mint', 'MC-732', '#B9D6BE', 'Green', 'MC-732_Mint.jpg'],
    ['Bliss', 'MC-735', '#DED4C1', 'Neutral', 'MC-735_Bliss.jpg'],
    ['Letter', 'MC-737', '#D4CBB7', 'Neutral', 'MC-737_Letter.jpg'],
    ['Zen', 'MC-740', '#C6BCA9', 'Neutral', 'MC-740_Zen.jpg'],
    ['Graystone', 'MC-743', '#ADA89A', 'Gray', 'MC-743_Graystone.jpg'],
    ['Clarity', 'MC-746', '#C7C2B8', 'Gray', 'MC-746_Clarity.jpg'],
    ['Tip-Taupe', 'MC-749', '#BEAB92', 'Neutral', 'MC-749_Tip-Taupe.jpg'],
    ['Villa', 'MC-751', '#C6B58F', 'Neutral', 'MC-751_Villa.jpg'],
    ['Light Coffee', 'MC-753', '#B4926F', 'Brown', 'MC-753_Light_Coffee.jpg'],
    ['Swiss Coffee', 'MC-756', '#E6DDCB', 'Neutral', 'MC-756_Swiss_Coffee.jpg'],
    ['Sandstorm', 'MC-758', '#CDB582', 'Neutral', 'MC-758_Sandstorm.jpg'],
    ['Antique', 'MC-760', '#C4AB87', 'Neutral', 'MC-760_Antique.jpg'],
    ['Faye', 'MC-762', '#BDA482', 'Neutral', 'MC-762_Faye.jpg'],
    ['Constellation', 'MC-765', '#A49B90', 'Gray', 'MC-765_Constellation.jpg'],
    ['Dolce', 'MC-767', '#D5C4A8', 'Neutral', 'MC-767_Dolce.jpg'],
    ['Peach', 'MC-769', '#E6BFA5', 'Pink', 'MC-769_Peach.jpg'],
    ['Slate', 'MC-771', '#83837F', 'Gray', 'MC-771_Slate.jpg'],
    ['Cafe', 'MC-774', '#83654F', 'Brown', 'MC-774_Cafe.jpg'],
    ['Mountain Fog', 'MC-777', '#B5B0A4', 'Gray', 'MC-777_Mountain_Fog.jpg'],
    ['Stone', 'MC-779', '#A5A091', 'Gray', 'MC-779_Stone.jpg'],
    ['Strokes of Taupe', 'MC-781', '#B49F80', 'Neutral', 'MC-781_Strokes_Of_Taupe.jpg'],
    ['Overcast', 'MC-783', '#9E9A8E', 'Gray', 'MC-783_Overcast.jpg'],
    ['Canvas', 'MC-786', '#D5C8AF', 'Neutral', 'MC-786_Canvas.jpg'],
    ['Recital', 'MC-789', '#948B78', 'Gray', 'MC-789_Recital.jpg'],
    ['Solitude', 'MC-791', '#ACA79B', 'Gray', 'MC-791_Solitude.jpg'],
    ['Fossil', 'MC-793', '#9C9382', 'Gray', 'MC-793_Fossil.jpg'],
    ['Walkway', 'MC-796', '#948F80', 'Gray', 'MC-796_Walkway.jpg'],
    ['Rocky', 'MC-799', '#837A6D', 'Gray', 'MC-799_Rocky.jpg'],
    ['Tarnished Silver', 'MC-801', '#A4A498', 'Gray', 'MC-801_Tarnished_Silver.jpg'],
    ['Lounge', 'MC-804', '#957A5D', 'Brown', 'MC-804_Lounge.jpg'],
    ['Concrete', 'MC-807', '#ACA69E', 'Gray', 'MC-807_Concrete.jpg'],
    ['Fairground', 'MC-809', '#CDB582', 'Neutral', 'MC-809_Fairground.jpg'],
    ['Balboa Gray', 'MC-812', '#A4A092', 'Gray', 'MC-812_Balboa_Gray.jpg'],
    ['Shaded', 'MC-814', '#7B7261', 'Gray', 'MC-814_Shaded.jpg'],
    ['Bound', 'MC-816', '#73614E', 'Brown', 'MC-816_Bound.jpg'],
    ['Dusk', 'MC-819', '#5F6660', 'Blue', 'MC-819_Dusk.jpg'],
    ['Structure', 'MC-821', '#6C6355', 'Gray', 'MC-821_Structure.jpg'],
    ['Damask', 'MC-824', '#944336', 'Red', 'MC-824_Damask.jpg'],
    ['Dark Denim', 'MC-826', '#354657', 'Blue', 'MC-826_Dark_Denim.jpg'],
    ['Bayou', 'MC-829', '#4C5B45', 'Green', 'MC-829_Bayou.jpg'],
    ['Deep Teal', 'MC-831', '#1E4B4A', 'Blue', 'MC-831_Deep_Teal.jpg'],
    ['Marlboro Blue', 'MC-834', '#3D5766', 'Blue', 'MC-834_Marlboro_Blue.jpg'],
    ['Pistachio', 'MC-836', '#A4BE93', 'Green', 'MC-836_Pistachio.jpg'],
    ['Sage', 'MC-838', '#94A484', 'Green', 'MC-838_Sage.jpg'],
    ['Morning Dew', 'MC-840', '#BCCDB2', 'Green', 'MC-840_Morning_Dew.jpg'],
    ['Olive', 'MC-843', '#6A7333', 'Green', 'MC-843_Olive.jpg'],
    ['Rose', 'MC-845', '#D3A2A2', 'Pink', 'MC-845_Rose.jpg'],
    ['Ballerina', 'MC-847', '#DEB4B4', 'Pink', 'MC-847_Ballerina.jpg'],
    ['Flow', 'MC-850', '#6E93A2', 'Blue', 'MC-850_Flow.jpg'],
    ['Violet Essence', 'MC-852', '#8C739C', 'Purple', 'MC-852_Violet_Essence.jpg'],
    ['Presto', 'MC-854', '#DDC363', 'Yellow', 'MC-854_Presto.jpg'],
    ['Sunny Day', 'MC-857', '#EFD473', 'Yellow', 'MC-857_Sunny_Day.jpg'],
    ['Medallion', 'MC-859', '#C39544', 'Yellow', 'MC-859_Medallion.jpg'],
    ['Deep Gold', 'MC-862', '#B37B2C', 'Orange', 'MC-862_Deep_Gold.jpg'],
    ['Flowerpot', 'MC-864', '#C4642F', 'Orange', 'MC-864_Flowerpot.jpg'],
    ['Pottery', 'MC-866', '#B3744B', 'Brown', 'MC-866_Pottery.jpg'],
    ['Ombia', 'MC-869', '#936C44', 'Brown', 'MC-869_Ombia.jpg'],
    ['Canal', 'MC-871', '#4C6373', 'Blue', 'MC-871_Canal.jpg'],
    ['Ruby Red', 'MC-873', '#9C2530', 'Red', 'MC-873_Ruby_Red.jpg'],
    ['Brickyard', 'MC-875', '#A35233', 'Red', 'MC-875_Brickyard.jpg'],
    ['Red Wine', 'MC-877', '#6B242D', 'Red', 'MC-877_Red_Wine.jpg'],
    ['Mauve Brown', 'MC-880', '#836055', 'Brown', 'MC-880_Mauve_Brown.jpg'],
    ['Cocoa', 'MC-883', '#563423', 'Brown', 'MC-883_Cocoa.jpg'],
    ['Charcoal', 'MC-885', '#3D3D3D', 'Gray', 'MC-885_Charcoal.jpg'],
    ['Obsidian', 'MC-888', '#262626', 'Black', 'MC-888_Obsidian.jpg'],
    ['Granite', 'MC-890', '#545249', 'Gray', 'MC-890_Granite.jpg'],
    ['Dark Knight', 'MC-893', '#1E1E1E', 'Black', 'MC-893_Dark_Knight.jpg'],
    ['Deep Sea', 'MC-896', '#142C42', 'Blue', 'MC-896_Deep_Sea.jpg'],
    ['M-Black', 'MC-899', '#151515', 'Black', 'MC-899_M-Black.jpg'],
  ].map(([name, code, hex, family, filename]) => [name, code, hex, family, CDN_BASE + filename]);

  let _selectedColor = null;
  let _activeFamily  = 'all';
  let _searchQuery   = '';
  let _tooltipTarget = null;
  let _tooltipTimer  = null;

  const $ = (id) => document.getElementById(id);

  function init() {
    const overlay       = $('md-modal-overlay');
    const triggerBtn    = $('md-selected-display');
    const closeBtn      = $('md-close-btn');
    const searchInput   = $('md-search-input');
    const searchClear   = $('md-search-clear');
    const grid          = $('md-color-grid');
    const familyPills   = document.querySelectorAll('.md-family-pill');
    const tooltip       = $('md-tooltip');
    const tooltipSelect = $('md-tooltip-select');
    const hiddenInput   = $('md-selected-color-input');

    if (!overlay) return; // snippet not on page

    triggerBtn.addEventListener('click', () => {
      overlay.hidden = false;
      triggerBtn.setAttribute('aria-expanded', 'true');
      searchInput.focus();
      renderGrid();
    });

    const closeModal = () => {
      overlay.hidden = true;
      triggerBtn.setAttribute('aria-expanded', 'false');
      hideTooltip();
    };

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) closeModal();
    });

    searchInput.addEventListener('input', () => {
      _searchQuery = searchInput.value.trim().toLowerCase();
      searchClear.hidden = _searchQuery.length === 0;
      renderGrid();
    });
    searchClear.addEventListener('click', () => {
      searchInput.value = '';
      _searchQuery = '';
      searchClear.hidden = true;
      searchInput.focus();
      renderGrid();
    });

    familyPills.forEach((pill) => {
      pill.addEventListener('click', () => {
        familyPills.forEach((p) => p.classList.remove('active'));
        pill.classList.add('active');
        _activeFamily = pill.dataset.family;
        renderGrid();
      });
    });

    tooltipSelect.addEventListener('click', () => {
      if (_tooltipTarget) {
        selectColor(_tooltipTarget);
        hideTooltip();
        closeModal();
      }
    });

    const form = triggerBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!_selectedColor) {
          e.preventDefault();
          triggerBtn.style.borderColor = '#c0392b';
          triggerBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          alert('Please select a paint color before adding to cart.');
          return false;
        }
      });
    }

    function getFilteredColors() {
      return MEODED_COLORS.filter((c) => {
        const [name, code, , family] = c;
        const matchesFamily = _activeFamily === 'all' || family === _activeFamily;
        const matchesSearch = !_searchQuery ||
          name.toLowerCase().includes(_searchQuery) ||
          code.toLowerCase().includes(_searchQuery);
        return matchesFamily && matchesSearch;
      });
    }

    function escapeAttr(str) {
      return String(str).replace(/"/g, '&quot;');
    }

    function renderGrid() {
      const noResults = $('md-no-results');
      const countEl   = $('md-results-count');

      if (_activeFamily === 'custom') {
        noResults.hidden = true;
        countEl.textContent = 'Custom Color';

        grid.innerHTML = `
          <div class="md-custom-color-wrap">
            <div class="md-custom-preview">
              <div class="md-preview-info" style="width:100%;">
                <label>Color Name or Color Code</label>
                <input type="text" id="md-custom-name" placeholder="Sage or MC-838">
              </div>
            </div>
            <button type="button" class="md-custom-select" id="md-custom-select">
              ✓ Use this Color
            </button>
          </div>
        `;

        const input = document.getElementById('md-custom-name');
        document.getElementById('md-custom-select').addEventListener('click', () => {
          const value = input.value.trim();
          if (!value) {
            input.focus();
            return;
          }
          selectColor({ name: value, code: '', hex: '.' });
          closeModal();
        });
        return;
      }

      const colors = getFilteredColors();
      countEl.textContent = colors.length + ' Results';

      if (colors.length === 0) {
        grid.innerHTML = '';
        noResults.hidden = false;
        return;
      }
      noResults.hidden = true;

      grid.innerHTML = colors.map(([name, code, hex, , imageUrl]) => {
        const luminance  = getLuminance(hex);
        const lightText  = luminance < 0.35 ? 'light-text' : '';
        const isSelected = _selectedColor && _selectedColor.code === code;
        return `<div
          class="md-color-cell${lightText ? ' ' + lightText : ''}${isSelected ? ' selected' : ''}"
          style="background-color:${hex}; background-image:url('${imageUrl}'); background-size:cover; background-position:center;"
          data-name="${escapeAttr(name)}"
          data-code="${code}"
          data-hex="${hex}"
          data-image="${escapeAttr(imageUrl)}"
          role="option"
          aria-selected="${isSelected}"
          tabindex="0"
          title="${name} ${code}"
        >${name}</div>`;
      }).join('');

      grid.querySelectorAll('.md-color-cell').forEach((cell) => {
        cell.addEventListener('mouseenter', (e) => showTooltip(cell, e));
        cell.addEventListener('mouseleave', () => scheduleHideTooltip());
        cell.addEventListener('click', () => {
          const color = { name: cell.dataset.name, code: cell.dataset.code, hex: cell.dataset.hex, imageUrl: cell.dataset.image };
          selectColor(color);
          closeModal();
        });
        cell.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const color = { name: cell.dataset.name, code: cell.dataset.code, hex: cell.dataset.hex, imageUrl: cell.dataset.image };
            selectColor(color);
            closeModal();
          }
        });
      });

      tooltip.addEventListener('mouseenter', () => clearTimeout(_tooltipTimer));
      tooltip.addEventListener('mouseleave', () => scheduleHideTooltip());
    }

    function showTooltip(cell) {
      clearTimeout(_tooltipTimer);
      _tooltipTarget = { name: cell.dataset.name, code: cell.dataset.code, hex: cell.dataset.hex, imageUrl: cell.dataset.image };

      const swatchEl = $('md-tooltip-swatch');
      swatchEl.style.backgroundColor = cell.dataset.hex;
      swatchEl.style.backgroundImage = cell.dataset.image ? `url('${cell.dataset.image}')` : 'none';
      swatchEl.style.backgroundSize = 'cover';
      swatchEl.style.backgroundPosition = 'center';
      $('md-tooltip-name').textContent = cell.dataset.name;
      $('md-tooltip-code').textContent = cell.dataset.code;
      tooltip.hidden = false;

      const cellRect  = cell.getBoundingClientRect();
      const gridRect  = grid.getBoundingClientRect();
      const tipWidth  = 230;
      const tipHeight = 80;

      let left = cellRect.right - gridRect.left + 8;
      let top  = cellRect.top  - gridRect.top;

      if (left + tipWidth > gridRect.width) {
        left = cellRect.left - gridRect.left - tipWidth - 8;
      }
      if (top + tipHeight > gridRect.height) {
        top = gridRect.height - tipHeight - 8;
      }

      tooltip.style.left = Math.max(0, left) + 'px';
      tooltip.style.top  = Math.max(0, top)  + 'px';
    }

    function scheduleHideTooltip() {
      _tooltipTimer = setTimeout(hideTooltip, 200);
    }

    function hideTooltip() {
      tooltip.hidden = true;
      _tooltipTarget = null;
    }
  }

  function selectColor(color) {
    _selectedColor = color;
document.getElementById('md-selected-display').style.setProperty('background', '#fff', 'important');
    const display     = $('md-selected-display');
    const nameEl       = $('md-selected-name');
    const iconEl       = $('md-swatch-icon');
    const hiddenInput  = $('md-selected-color-input');

    if (!display) return;

    display.style.backgroundColor = color.hex;
    if (color.imageUrl) {
      display.style.backgroundImage = `url('${color.imageUrl}')`;
      display.style.backgroundSize = 'cover';
      display.style.backgroundPosition = 'center';
    }
    display.style.borderColor = 'transparent';
    display.classList.add('has-color');

    const luminance = getLuminance(color.hex);
    const textColor = luminance < 0.35 ? '#fff' : '#1a1a1a';
    display.style.color = textColor;
    display.style.textShadow = color.imageUrl ? '0 1px 3px rgba(0,0,0,.6)' : 'none';

    nameEl.textContent = `${color.name} ${color.code}`;

    iconEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#C62036" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <path d="M14 4l6 6-8 8H6v-6z"></path>
  <path d="M6 18c-1.5 0-3 1-3 2.5S4.5 23 6 23s3-1 3-2.5S7.5 18 6 18z"></path>
</svg>`;

    hiddenInput.value = `${color.name} (${color.code})`;
  }

  function getLuminance(hex) {
    if (!hex || hex.charAt(0) !== '#' || hex.length < 7) return 1;
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    const toLinear = (c) => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
